import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import type { Theme } from 'theme/contracts';

export function useTheme(): Theme {
  return useContext(ThemeContext);
}
